import React, { useState } from 'react'
import { Button, CircularProgress, DialogContainer, List, ListItem } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { useCSVDownloader, useCSVReader } from 'react-papaparse';
import { BeatLoader } from 'react-spinners';
import CSVFileValidator from 'csv-file-validator'
import ReactTooltip from 'react-tooltip';

const SFBulkUploadButton = (props) => {
    console.debug("props", props)

    const { CSVReader } = useCSVReader();
    const { CSVDownloader } = useCSVDownloader();

    const [showBulkDialog, setShowBulkDialog] = useState(false);
    const [errorData, setErrorData] = useState([]);

    const transformHeader = (header) => {
        return header.replace(/\s+/g, '_').toLowerCase();
    };

    const validateData = (results, file) => {
        CSVFileValidator(file, props.config)
            .then(csvData => {
                console.debug("csvData>>>", csvData);
                if (csvData && csvData.inValidData && csvData.inValidData.length) {
                    // NotificationManager.warning(csvData.inValidData[0].message, 'CSV Parsing Failed')
                    setErrorData(csvData.inValidData);
                    setShowBulkDialog(true)
                    return
                } else {
                    setErrorData([]);
                    setShowBulkDialog(false);


                    if (csvData && csvData.data && csvData.data.length) {
                        props.handleBulkUpload(csvData.data)
                    }
                }

            })
            .catch(err => {
                console.debug("err", err)
                NotificationManager.error('Something went wrong', 'Error')
            })
    }

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            }}
        >

            <DialogContainer
                visible={showBulkDialog}
                title="CSV parsing failed"
                focusOnMount={false}
                width={800}
                onHide={() => {
                    setErrorData([]);
                    setShowBulkDialog(false);
                }}
            >
                <div style={{marginLeft:'1.6rem'}}>
                    <p>Please fix the following errors in your CSV and try again:</p>
                </div>
                
                <List>
                    {errorData && errorData.map((data, index) => {
                        return <ListItem key={index} primaryText={
                            `${index + 1}. ${data.message}`
                        } />
                    })}
                </List>

            </DialogContainer>

            <CSVReader
                onUploadAccepted={validateData}
                noProgressBar
                config={{
                    header: true,
                    skipEmptyLines: true,
                    transformHeader: transformHeader,
                    dynamicTyping: true,
                }}
            >
                {({ getRootProps,
                    acceptedFile,
                    ProgressBar,
                    getRemoveFileProps }) => (
                    <div>
                        <Button
                            disabled={props.loading}
                            raised
                            primary
                            {...getRootProps()}
                        >
                            <BeatLoader color={'#bb0000'} size={10} loading={props.loading} />
                            {!props.loading ? <div>Bulk Upload</div> : null}
                        </Button>
                    </div>
                )}
            </CSVReader>
            <span>
                <CSVDownloader
                    data={[props.headers]}
                    filename={props.templateFileName}
                    bom={true}
                    style={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                    }}
                >

                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Button className='nocqcStyle' style={{ marginTop: '6px' }} icon data-tip data-for='template-tooltip'>help</Button>
                        Download CSV Template
                    </div>
                    <ReactTooltip id='template-tooltip' type='light' className='tool-tip'>
                        <span>{props.tooltip}</span>
                    </ReactTooltip>

                </CSVDownloader>
            </span>
        </div>
    )
}

export default SFBulkUploadButton;
